import { fitTitle, fitDescription } from "@/lib/seo-text";
import { createFileRoute } from "@tanstack/react-router";

import { LocationPage } from "@/components/location-page";
import { faqSchema, FIRM, PEOPLE } from "@/lib/firm";
import { CONTENT } from "@/lib/locations/golden-beach";

const ERIN = PEOPLE.find((p) => p.slug === "erin-wilkinson")!;
const ERIN_IMAGE = `https://coastsidelaw.com.au${ERIN.photo}`;

export const Route = createFileRoute("/golden-beach")({
  head: () => ({
    meta: [
      { title: fitTitle(CONTENT.metaTitle) },
      { name: "description", content: fitDescription(CONTENT.description) },
      { property: "og:title", content: fitTitle(CONTENT.metaTitle) },
      { property: "og:description", content: fitDescription(CONTENT.description) },
      { property: "og:url", content: "/golden-beach" },
      { property: "og:type", content: "website" },
      { property: "og:image", content: ERIN_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: ERIN_IMAGE },
    ],
    links: [{ rel: "canonical", href: "/golden-beach" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(faqSchema(CONTENT.faqs)) },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          name: ERIN.name,
          jobTitle: ERIN.role,
          image: {
            "@type": "ImageObject",
            url: ERIN_IMAGE,
            caption: `${ERIN.name}, ${ERIN.role} at ${FIRM.name}, Golden Beach`,
          },
          url: "https://coastsidelaw.com.au/golden-beach",
          telephone: FIRM.phone,
          knowsAbout: [...ERIN.areas],
          workLocation: { "@type": "Place", name: "Golden Beach, Queensland" },
          worksFor: { "@id": "https://coastsidelaw.com.au/#legalservice" },
        }),
      },
    ],
  }),
  component: () => <LocationPage content={CONTENT} />,
});

